// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import tenantReducer from './tenantSlice'; // Import the tenant slice reducer
import utmReducer from './utmSlice';

const store = configureStore({
  reducer: {
    tenant: tenantReducer, // Add tenant reducer to the store
    utm: utmReducer,
  },
});

export default store;
